export default __webpack_public_path__ + "static/media/ofs_800_jacket.c5ed2405.jpg";